import React from 'react';
import './Style/ShippingPolicy.css';
import TopNavbar from './/../home/TopNavbar';
import AboutApp from '../AllData/AboutApp';

const ShippingPolicy = () => {
    return (
        <div className="shipping-policy-page">

            <TopNavbar name="Shipping Policy" />

            <div className="shipping-header">
                <h1>Shipping Policy</h1>
                <p className="last-updated">Last Updated: October 1, 2025</p>
            </div>

            <div className="shipping-content">
                {/* Digital Product Notice */}
                <div className="digital-product-banner">
                    <div className="digital-icon">🚀</div>
                    <h2>Digital Product - No Shipping Required</h2>
                    <p><strong>NEET Prep is a digital educational platform. No physical shipping involved.</strong></p>
                </div>

                {/* Policy Details */}
                <div className="policy-section">
                    <h3>1. Instant Digital Access</h3>
                    <p>
                        Since NEET Prep provides digital educational content, all materials are delivered instantly:
                    </p>
                    <ul>
                        <li>Immediate access upon successful payment</li>
                        <li>No waiting period for delivery</li>
                        <li>Available 24/7 through our app and website</li>
                        <li>No shipping costs or delivery timelines</li>
                    </ul>
                    <p>
                        Your study materials are accessible immediately after purchase through your account.
                    </p>
                </div>

                <div className="policy-section">
                    <h3>2. What You Get Instantly</h3>
                    <p>Upon successful payment, you receive immediate access to:</p>
                    <div className="access-list">
                        <div className="access-item">
                            <span className="item-icon">📚</span>
                            <div>
                                <strong>PDF Study Materials</strong>
                                <p>Formulas, notes, and study guides</p>
                            </div>
                        </div>
                        <div className="access-item">
                            <span className="item-icon">🧠</span>
                            <div>
                                <strong>Mind Maps</strong>
                                <p>Visual learning aids and concept maps</p>
                            </div>
                        </div>
                        <div className="access-item">
                            <span className="item-icon">📝</span>
                            <div>
                                <strong>Practice Questions</strong>
                                <p>Extensive question banks and tests</p>
                            </div>
                        </div>
                        <div className="access-item">
                            <span className="item-icon">📊</span>
                            <div>
                                <strong>Previous Year Papers</strong>
                                <p>NEET previous year question papers</p>
                            </div>
                        </div>
                        <div className="access-item">
                            <span className="item-icon">🎯</span>
                            <div>
                                <strong>Performance Analytics</strong>
                                <p>Detailed performance tracking and insights</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="policy-section">
                    <h3>3. Access Methods</h3>
                    <ul>
                        <li>Web Portal: Access through any web browser</li>
                        <li>Mobile App: Download our app from Play Store/App Store</li>
                        <li>Multi-device sync: Continue studying across devices</li>
                        <li>Offline access: Download materials for offline study</li>
                    </ul>
                </div>

                {/* Technical Requirements */}
                <div className="policy-section">
                    <h3>4. Technical Requirements</h3>
                    <p>To access our digital content, you need:</p>
                    <div className="requirements-grid">
                        <div className="requirement-item">
                            <strong>Internet Connection</strong>
                            <p>For initial access and updates</p>
                        </div>
                        <div className="requirement-item">
                            <strong>Compatible Device</strong>
                            <p>Smartphone, tablet, or computer</p>
                        </div>
                        <div className="requirement-item">
                            <strong>PDF Reader</strong>
                            <p>For viewing study materials</p>
                        </div>
                        <div className="requirement-item">
                            <strong>Updated Browser/App</strong>
                            <p>For optimal performance</p>
                        </div>
                    </div>
                </div>

                {/* Support Section */}
                <div className="support-section">
                    <h3>Need Help Accessing Content?</h3>
                    <p>
                        If you're having trouble accessing your digital content after purchase,
                        our support team is here to help:
                    </p>
                    <div className="support-contacts">
                        Email: <a href={"mailto:" + AboutApp[0].paymentsEmail} className='mail-link'> {AboutApp[0].paymentsEmail}</a><br></br>
                    </div>
                    <p className="support-note">
                        We typically respond within 24 hours and will help you resolve any access issues promptly.
                    </p>
                </div>
            </div>
            <br></br><br></br>
        </div>
    );
};

export default ShippingPolicy;